/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespBreadcrumbs_item$ref = any;
type PdpRespNotListedContent_item$ref = any;
type PdpRespSeoLinks_item$ref = any;
type PdpRespTitle_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainerNotListed_item$ref: FragmentReference;
export type PdpRespContainerNotListed_item = {|
  +$fragmentRefs: PdpRespBreadcrumbs_item$ref & PdpRespTitle_item$ref & PdpRespSeoLinks_item$ref & PdpRespNotListedContent_item$ref,
  +$refType: PdpRespContainerNotListed_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainerNotListed_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespBreadcrumbs_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespTitle_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSeoLinks_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespNotListedContent_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '06f61686cfcf0eb7c25a24e2cb64fef9';
module.exports = node;
